import { values } from '@morf/proto/values/v1/values_ts_proto';

export const formatValueDateToString = (date: values.v1.Date) =>
  `${date.month}/${date.day}/${date.year}`;
